/*
*@/components/cat4mro/item-purchase-thread
*/
export default {
  ItemPurchaseThread: {
    form: {
      title: 'Request for information Form',
      validation: {
        from: 'From:',
        to: {
          title: 'To:',
          button: 'Vendor',
        },
        element1: {
          name: 'Required Item Name',
          deadline: 'Close date',
        },
        element2: {
          divider1: 'Information to confirm availability',
          stock_confirmation: 'Stock Confirmation Request',
          validation1: {
            quantity: 'Quantity',
            measure_unit: 'UOM',
          },
          validation2: {
            divider1: 'Request for delivery availability',
            date: 'Required delivery date',
            delivery_location: 'Delivery Place',
          },
          checkbox: 'Allow vendor to propose new delivery date',
        },
        element3: {
          divider1: 'technical information',
          tech_specifications: 'Request technical specifications',
          validation1: {
            placeholder: 'Technical specifications',
          },
        },
        element4: {
          tech_warranty: 'Request guarantee / quality information ?',
          validation1: {
            placeholder: 'guarantee / quality information',
          },
        },
        element5: {
          tech_usage: 'request information about usage ?',
          validation1: {
            placeholder: 'information about usage',
          },
        },
        element6: {
          tech_manufacture: 'request information about origin / manufacturer ?',
          validation1: {
            placeholder: 'origin / manufacturer infomation',
          },
        },
        element7: {
          tech_additional_info: 'request for additional information ?',
          validation1: {
            placeholder: 'Additional information',
          },
        },
        element8: {
          divider1: 'Add document',
          validation1: {
            placeholder: 'Notes',
          },
        },
        send: ' Send',
      },
      title2: 'Supplier',
    },
    script: {
      components: {
        uploadAttachment: {
          attachment_button: ' Upload attachment ',
          max_size: 'Max file size allowed is 10MB',
          script: {
            handlerOnBeforeUpload: {
              isPDF: {
                title: 'Warning',
                message: 'Only PDF files are allowed.',
              },
              isLt10MB: {
                title: 'Warning',
                message: 'Max file size allowed is 10MB.',
              },
            },
          },
        },
      },
      methods: {
        send: {
          notify: {
            title: 'Information Request',
            message: 'Information request sent correctly',
          },
          catch: {
            title: 'Information Request',
            message: 'An error occurred while submitting your information request',
          },
        },
        confirmSend: {
          label1: 'do you want to submit the information request?',
          label2: 'Warning',
          confirmButton: 'OK',
          cancelButton: 'Cancel',
          notify: {
            title: 'Information Request',
            message: 'The information request has not been sent.',
          },
          catch: {
            title: 'Information Request',
            message: 'The information request has been canceled',
          },
        },
        handlerOnUploadedAttachment: {
          notify: {
            title: 'Upload File',
            message: 'File uploaded successfully',
          },
        },
        handlerOnErrorAttachment: {
          notify: {
            title: 'Upload File',
            message: 'The file could not be uploaded, please try again',
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/cat4mro/components/itemPurchaseThread.js